"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.Force = void 0;

var Term_1 = require("../Term");

exports.Force = new Term_1.Term('Force', 'FORCE', '$force', {
  log: function log(info) {
    if (info === void 0) {
      info = {};
    }

    return __assign({
      action: 'FORCE',
      force: true
    }, info);
  }
});